import Footer from "./Footer";
import Navbar from "./Navbar";

const WebLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer custumeClass="!bg-inherit !border-0" />
    </>
  )
}

export default WebLayout;